import { h, JSX } from "@stencil/core";

export default function MenuItemCountIndicator({
  count,
}: {
  count: number;
}): JSX.Element | null {
  if (count <= 0) return null;

  return (
    <phn-p-tag
      slot="suffix"
      class="menu-item-count"
      color="notification-info-soft"
    >
      {count}
    </phn-p-tag>
  );
}
